import dotProp from 'dot-prop-immutable';
import { getTopListKey } from 'live/components/index.shared';
import * as types from 'live/redux/actionTypes';

const defaultState = {
  dividends: {
    resolved: {},
    loading: {},
    errors: {},
  },
  profits: {
    resolved: {},
    loading: {},
    errors: {},
  },
};

// Top profits & dividends

const dividendsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case types.LIVE_TOP_LIST_REQUEST: {
      const { type, month, year } = action.meta;
      const key = getTopListKey({ month, year });

      return dotProp.set(state, type, {
        resolved: dotProp.set(state[type].resolved, key, []),
        loading: dotProp.set(state[type].loading, key, true),
        errors: dotProp.set(state[type].errors, key),
      });
    }

    case types.LIVE_TOP_LIST_RECEIVE: {
      const { content } = action.payload;
      const { type, month, year } = action.meta;
      const key = getTopListKey({ month, year });

      return dotProp.set(state, type, {
        resolved: dotProp.set(state[type].resolved, key, content),
        loading: dotProp.set(state[type].loading, key, false),
        errors: dotProp.set(state[type].errors, key),
      });
    }

    case types.LIVE_TOP_LIST_ERROR: {
      const error = action.payload;
      const { type, month, year } = action.meta;
      const key = getTopListKey({ month, year });

      return dotProp.set(state, type, {
        resolved: dotProp.set(state[type].resolved, key, []),
        loading: dotProp.set(state[type].loading, key, false),
        errors: dotProp.set(state[type].errors, key, error.message),
      });
    }

    default:
      return state;
  }
};

export default dividendsReducer;
